module.exports = __webpack_public_path__ + "static/media/img_fistbump.66854d7e.png";